import { createContext } from 'react';

import { EventManager } from '../../core/index.js';

export const EventManagerContext = createContext<EventManager | null>(null);
